module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl m-r-30"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'userAdd'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加游客")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入账号/真实姓名/最近登录企业",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_head",
      "label": "头像",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right-end",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "100%"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "50",
            "height": "50"
          },
          slot: "reference"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "账号",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "真实姓名",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "注册时间",
      "width": "180",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticClass: "success_status"
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticClass: "goon_status"
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "error_status"
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'user_add_companyList',
                params: {
                  id: scope.row.id,
                  username: scope.row.username
                }
              })
            }
          }
        }, [_vm._v("添加企业")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'userEdit',
                params: {
                  id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v("编辑")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'user'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-089f62f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/user/list.vue
// module id = 1797
// module chunks = 2